<template>
  <v-dialog
    hide-overlay
    :overlay-opacity="0"
    transition="fade-transition"
    persistent
    ref="dialog"
    v-model="isOpen"
    absolute
  >
    <div class="card-overlay" @click="$refs.dialog.animateClick()" />

    <v-card style="width: 560px" class="" v-if="isOpen">
      <v-card-text height="800px" class="px-8 pt-8">
        <div class="mb-8 d-flex align-start">
          <div class="d-flex flex-column">
            <span class="font-weight-light p-1 base--text">
              {{ $t('heading.onboarding.import.url.title') }}
            </span>
            <h4 class>{{ $t('heading.onboarding.import.url.subtitle') }}</h4>
          </div>

          <v-btn x-small icon @click="$emit('remove-modal')" class="ml-auto">
            <v-icon size="24" color="gray">$close</v-icon>
          </v-btn>
        </div>

        <div class="selection-box">
          <checkbox-big
            class="pa-6"
            :checked="selectedMethod === 'plugin'"
            @check="selectedMethod ='plugin'"
          >
            <template v-slot:custom>
              <div class="text-left" style="height: 100%">
                <h5 class="p-1">
                  <span>{{ $t('heading.onboarding.chooseImportMethod.simple.title') }}</span>
                </h5>
                <p class="mb-4">{{ $t('general.recommended') }}</p>
                <p class="p-2 font-weight-thin mb-0" v-html="$t('heading.onboarding.chooseImportMethod.simple.description')"/>
              </div>
            </template>
          </checkbox-big>
          <checkbox-big
            class="pa-6"
            :checked="selectedMethod === 'ftp'"
            @check="selectedMethod = 'ftp'"
          >
            <template v-slot:custom>
              <div class="text-left" style="height: 100%">
                <h5 class="p-1 mb-4">
                  <span>{{ $t('heading.onboarding.chooseImportMethod.advanced.title') }}</span>
                </h5>
                <p class="p-2 font-weight-thin mb-0" v-html="$t('heading.onboarding.chooseImportMethod.advanced.description')"/>
              </div>
            </template>
          </checkbox-big>
        </div>
      </v-card-text>

      <v-card-actions
        class="pt-8 d-flex align-center justify-space-between"
        :class="$vuetify.breakpoint.width < 550 ? 'flex-column-reverse' : ''"
      >
        <div :class="$vuetify.breakpoint.width < 550 ? 'mt-4 w-100' : ''">
          <step-indicator :currentStep="maxSteps - 1" :maxSteps="maxSteps" />
        </div>
        <div
          class="d-flex align-center"
          :class="
            $vuetify.breakpoint.width < 550 ? 'flex-column-reverse w-100' : ''
          "
        >
          <v-btn
            large
            @click="$emit('remove-modal')"
            text
            :block="$vuetify.breakpoint.width < 550 ? true : false"
            elevation="0"
            class="mr-3"
          >
            <span class="font-weight-bold gray--text text--darken-1">
             {{ $t('button.cancel') }}
            </span>
          </v-btn>
          <v-btn
            large
            @click="selectType()"
            color="primary"
            :block="$vuetify.breakpoint.width < 550 ? true : false"
            elevation="0"
          >
            <span class="font-weight-bold">
              {{ $t('button.continue') }}
            </span>
            <v-icon class="ml-2 mr-0" size="20">$arrowright</v-icon>

          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import StepIndicator from "../StepIndicator.vue";
import CheckboxBig from "@/components/buttons/CheckboxBig.vue";

export default {
  name: "OnboardingChooseImportMethodModal",
  components: {
    CheckboxBig,
    StepIndicator,
  },
  props: {
    isOpen: Boolean,
    maxSteps: Number,
  },
  data: () => ({
    selectedMethod: 'plugin',
  }),
  methods: {
    selectType() {
      this.$emit('import-method-selected', this.selectedMethod);
    }
  },
  watch: {
    isOpen: function (value) {
      this.selectedMethod = 'plugin';

      if (value) {
        this.$nextTick(() => {
          this.$store.dispatch("lockBodyScroll");
        });
      } else {
        this.$store.dispatch("unlockBodyScroll");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-dialog__content::v-deep {
  .v-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.v-card::v-deep {
  .selection-box {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    .checkbox-big {
      border-radius: 8px;
      &::after {
        border-radius: 8px;
      }
    }
    @media (max-width: 700px) {
      grid-template-columns: 1fr;
    }
  }
  .v-card__text {
    -webkit-line-clamp: unset !important;
  }
  @media (max-width: 480px) {
    .v-card__text,
    .v-card__actions {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}
</style>
